import { useQuery } from "@tanstack/react-query";
import type { QaRawDataResponse } from "@gw/shared-types";
import { getQaRawData } from "@/api/endpoints";

export function useQaRawDataQuery(id: string | undefined) {
  return useQuery<QaRawDataResponse>({
    queryKey: ["qa", id],
    queryFn: () => getQaRawData(id!),
    enabled: !!id,
    staleTime: 60_000,
  });
}
